'use client';

import { Radio } from '@lichtblick/photon/atoms/radio';
import { CheckInputCard } from '@lichtblick/photon/molecules/check-input-card';
import Image from 'next/image';

import { MediaCardSlider } from '../../components/media-card-slider/media-card-slider';
import { i18n } from '../../i18n';

type CardSliderProps = {
  sourceOfHeat?: string;
};

export const CardSlider = ({ sourceOfHeat }: CardSliderProps) => (
  <MediaCardSlider desktopColumns={2} errorMessage={i18n.validation.missing}>
    <CheckInputCard
      copy="Wärmepumpen befinden sich meist in Kellern oder Heizungsräumen. Luft-Wasser-Modelle nutzen einen Kessel für die Warmwasseraufbereitung und einen Ventilator draußen am Haus."
      data-testid="radio-wrapper-heatpump"
      image={<Image alt="Wärmepumpe" height={144} src="/checkout-b2c/assets/heatpump.jpg" width={256} />}
      label="Wärmepumpe"
    >
      <Radio
        data-testid="radio-wrapper-heatpump"
        defaultChecked={sourceOfHeat === 'HEAT_PUMP'}
        name="sourceOfHeat"
        onChange={(e) => {
          e.target.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start',
          });
        }}
        onInvalid={(e) => {
          e.preventDefault();
        }}
        required
        value="HEAT_PUMP"
      />
    </CheckInputCard>
    <CheckInputCard
      copy="Nachtspeicherheizungen sind kompakte Elektroheizungen. In ihrer Hülle befindet sich neben einem Speicherkern meist auch ein Ventilator."
      data-testid="radio-wrapper-storage-heater"
      image={
        <Image alt="Nachtspeicherheizung" height={144} src="/checkout-b2c/assets/storage-heater.jpg" width={256} />
      }
      label="Nachtspeicherheizung"
    >
      <Radio
        data-testid="radio-wrapper-storage-heater"
        defaultChecked={sourceOfHeat === 'STORAGE_HEATER'}
        name="sourceOfHeat"
        onChange={(e) => {
          e.target.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start',
          });
        }}
        onInvalid={(e) => {
          e.preventDefault();
        }}
        required
        value="STORAGE_HEATER"
      />
    </CheckInputCard>
  </MediaCardSlider>
);
